var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('v-navigation-drawer',{staticClass:"agenda-panel",attrs:{"app":"","right":"","permanent":"","width":"300","color":"surface"}},[_c('agenda-panel-body')],1):_c('div',{staticClass:"agenda-panel--mobile"},[_c('agenda-panel-body')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }